"use client";

import Icon from "../../common/components/Icon";
import React, { useState } from "react";
import Button from "./Button";

export interface FilterCardProps {
  initialCollapsed?: boolean;
  collapsible?: boolean;
  title: string;
  children?: React.ReactNode;
  onSettingsClicked?: (optionValue?: any) => void;
}

const FilterCard: React.FC<FilterCardProps> = ({
  children,
  initialCollapsed = false,
  collapsible = false,
  title,
  onSettingsClicked,
}) => {
  const [collapsed, setCollapsed] = useState(
    collapsible ? initialCollapsed : false,
  );

  const onTitleClicked = collapsible
    ? () => setCollapsed(!collapsed)
    : undefined;

  const showSettings = () => {
    onSettingsClicked();
  };

  return (
    <div
      aria-expanded={!collapsed}
      className="filter-card color-bg-surface-input border-radius p-2 d-flex flex-column gap-1"
    >
      <div className="d-flex justify-content-between align-items-center py-1">
        <button className="fw-semibold" onClick={onTitleClicked}>
          {title}
        </button>
        <span className="d-flex align-items-center gap-2">
          {onSettingsClicked ? (
            <Button
              icon={<Icon icon="playlist-add" className="icon" />}
              appearance="quaternary"
              onClick={showSettings}
            />
          ) : null}
          {onTitleClicked ? (
            <button
              className="fw-semibold d-flex align-items-center"
              onClick={onTitleClicked}
            >
              <Icon icon="chevron-down" className="icon--md" />
            </button>
          ) : null}
        </span>
      </div>
      {collapsed ? null : children}
    </div>
  );
};

export default FilterCard;
